import { mode } from '../../../../../config';

const hideLoginAdditionalFooter = (): boolean => {
    return mode.isTaiwan();
};

export default {
    hideLoginAdditionalFooter,
};
